import { useStudioLocale } from '@/i18n'

interface ReviewObservationDisclosureProps {
  observedAt: string
  evidenceRefs: readonly string[]
  scope: string
  state?: 'measured' | 'empty'
}

export function ReviewObservationDisclosure({
  observedAt,
  evidenceRefs,
  scope,
  state = 'measured',
}: ReviewObservationDisclosureProps) {
  const { strings, locale } = useStudioLocale()
  const copy = strings.businessScreens.review.observation
  // The VIEWER's locale, not the host's. `undefined` here means "whatever
  // this browser is set to", which on a ko screen in an en-US profile
  // printed `Aug 1, 2026` — measured on the seeded render, where it is the
  // only Latin word the four Operations screens still produced.
  const observedLabel = new Intl.DateTimeFormat(locale, {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(observedAt))

  const disclosure = (
    <details
      open
      className="rounded-lg border border-border bg-muted/30 px-4 py-3 text-sm text-muted-foreground"
    >
      <summary className="cursor-pointer font-medium text-foreground">
        {state === 'measured' ? copy.measuredSummary : copy.emptySummary}
      </summary>
      <div className="mt-2 space-y-1">
        <p>{scope}</p>
        <p>{copy.observedAt(observedLabel)}</p>
        <p>
          {copy.evidence} {evidenceRefs.map((ref, index) => (
            <span key={ref}>
              {index > 0 ? ', ' : ''}{ref}
            </span>
          ))}
        </p>
      </div>
    </details>
  )

  return state === 'measured' ? <div role="status">{disclosure}</div> : disclosure
}
